import PropTypes from 'prop-types';
import { useSettingsContext } from 'src/components/settings';
import DashboardFiltersLayout from './dashboard-filters-layout';

export default function DashboardPageLayout({ header, children, filtersConfig }) {
  const settings = useSettingsContext();

  const isHorizontal = settings.themeLayout === 'horizontal';

  const showHeader =
    !isHorizontal ||
    (filtersConfig && filtersConfig.showHeaderOnHorizontal === true);

  const showCancelledFilter =
  filtersConfig && filtersConfig.showCancelledFilter === true;

  return (
    <>
      {showHeader && header}

      <DashboardFiltersLayout showCancelledFilter={showCancelledFilter}>
        {children}
      </DashboardFiltersLayout>
    </>
  );
}

DashboardPageLayout.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node,
  filtersConfig: PropTypes.object
};